import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, from } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
import { ToastService } from '../shared/custom-overlay/toast/toast.service';
import { ConfirmedValidator } from '../shared/validators/matchPassword.validator';
import { VerifyPasswordCombination } from '../shared/validators/passwordStrength.validator';
import { PrePasswordValidator } from '../shared/validators/prepwdAsync.validator';
import { UserLoginService } from './user-login.service';
import { TerminateSessionComponent } from './terminate-session/terminate-session.component'
import { SharedService } from '../services/shared.service';
import { ToastType } from '../shared/shared.enums';
import { KeyValue } from '@angular/common';
import * as d3 from 'd3';


// from metadata errors object is sent to oneError pipe with the error
@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('UName') UNameRef: ElementRef;
  @ViewChild('pwd') pwdRef: ElementRef;
  @ViewChild('signIn') signInRef: ElementRef;


  actions={
    "actions": {
      "0": {
        "disp": "Triggered",
        "value": "0",
        "status": "open",
        "priority": false,
        "reassign": false,
        "isDefault": true,
        "next": [
          "1"
        ],
        "reason": {
          "0": {
            "value": "-",
            "disp": "-"
          }
        }
      },
      "1": {
        "disp": "Acknowledged",
        "value": "1",
        "status": "open",
        "priority": false,
        "reassign": false,
        "isDefault": true,
        "next": [
          "3",
          "2",
          "4",
          "5"
        ],
        "reason": {
          "0": {
            "value": "-",
            "disp": "-"
          }
        }
      },
      "2": {
        "disp": "Waiting",
        "value": "2",
        "status": "open",
        "priority": false,
        "reassign": false,
        "isDefault": false,
        "next": [
          "3",
          "5"
        ],
        "reason": {
          "0": {
            "disp": "Monitoring",
            "value": "0"
          },
          "1": {
            "disp": "Investigating",
            "value": "1"
          },
          "2": {
            "disp": "Requires additional evidence",
            "value": "2"
          },
          "3": {
            "disp": "Awaiting customer response",
            "value": "3"
          }
        }
      },
      "3": {
        "disp": "Closed",
        "value": "3",
        "status": "close",
        "priority": false,
        "reassign": false,
        "isDefault": false,
        "next": [],
        "reason": {
          "0": {
            "disp": "Benign",
            "value": "0"
          },
          "1": {
            "disp": "False Positive",
            "value": "1"
          },
          "2": {
            "disp": "Known Activity",
            "value": "2"
          },
          "3": {
            "disp": "Duplicate",
            "value": "3"
          },
          "4": {
            "disp": "Policy Exception",
            "value": "4"
          },
          "5": {
            "disp": "Test Alert",
            "value": "5"
          }
        }
      },
      "4": {
        "disp": "Re-assigned",
        "value": "4",
        "status": "close",
        "priority": true,
        "reassign": true,
        "isDefault": false,
        "next": [],
        "reason": {
          "0": {
            "disp": "Domain ownership",
            "value": "0"
          },
          "1": {
            "disp": "Incorrect assignment",
            "value": "1"
          },
          "2": {
            "disp": "Review",
            "value": "2"
          },
          "3": {
            "disp": "Escalation",
            "value": "3"
          },
          "4": {
            "disp": "Other",
            "value": "4"
          }
        }
      },
      "5": {
        "disp": "Promoted",
        "value": "5",
        "status": "close",
        "priority": true,
        "reassign": false,
        "isDefault": false,
        "next": [],
        "reason": {
          "0": {
            "value": "-",
            "disp": "-"
          }
        }
      }
    }
  }

  getActions(){
    let arr=[]
    Object.keys(this.actions.actions).forEach((list:any)=>{
      if(!this.actions.actions[list].isDefault){
        let obj ={}
        obj["disp"]=this.actions.actions[list].disp
        obj["value"]=this.actions.actions[list].value
        arr.push(obj)
      }
    })
    return arr
  }

  getreason(action){
    let arr=[]
    Object.keys(this.actions.actions[action].reason).forEach((list:any)=>{
      let obj ={}
      obj["disp"]=this.actions.actions[action].reason[list].disp
      obj["value"]=this.actions.actions[action].reason[list].value
      arr.push(obj)
    })
    return arr
  }

  action = new FormControl()




  nestedDropdown=[
    {
      "disp": "Port",
      "value": [
        {
          "disp": "Srcport",
          "value": "srcport",
          "type":"number",
          "state":1
        },
        {
          "disp": "Dstport",
          "value": "dstport",
          "type":"number",
          "state":1
        }
      ],
      "state":1
    },
    {
      "disp": "IP",
      "value": [
        {
          "disp": "Srcip",
          "value": "srcip",
          "type":"inet",
          "state":1
        },
        {
          "disp": "Dstip",
          "value": "dstip",
          "type":"inet",
          "state":1
        }
      ],
      "state":1
    }
  ]


  sampleData={
    "roots": [
      "firewall",
      "os",
      "switch",
      "router",
      "o365"
    ],
    "nodes": {
      "firewall": {
        "id": "firewall",
        "label": "Firewall",
        "level": "Technology",
        "parentId": "",
        "parentLevel": "",
        "childrenIds": [
          "firewall/fortinet",
          "firewall/paloalto"
        ]
      },
      "os": {
        "id": "os",
        "label": "OS",
        "level": "Technology",
        "parentId": "",
        "parentLevel": "",
        "childrenIds": [
          "os/microsoft"
        ]
      },
      "switch": {
        "id": "switch",
        "label": "Switch",
        "level": "Technology",
        "parentId": "",
        "parentLevel": "",
        "childrenIds": [
          "switch/cisco"
        ]
      },
      "router": {
        "id": "router",
        "label": "Router",
        "level": "Technology",
        "parentId": "",
        "parentLevel": "",
        "childrenIds": [
          "router/cisco"
        ]
      },
      "o365": {
        "id": "o365",
        "label": "O365",
        "level": "Technology",
        "parentId": "",
        "parentLevel": "",
        "childrenIds": [
          "o365/exchange",
          "o365/onedrive",
          "o365/sharepoint"
        ]
      },
      "firewall/fortinet": {
        "id": "firewall/fortinet",
        "label": "Fortinet",
        "level": "Vendor/Product",
        "parentId": "firewall",
        "parentLevel": "Technology",
        "childrenIds": [
          "firewall/fortinet/fortigate",
          "firewall/fortinet/fw1",
          "firewall/fortinet/general"
        ]
      },
      "firewall/paloalto": {
        "id": "firewall/paloalto",
        "label": "PaloAlto",
        "level": "Vendor/Product",
        "parentId": "firewall",
        "parentLevel": "Technology",
        "childrenIds": [
          "firewall/paloalto/general"
        ]
      },
      "os/microsoft": {
        "id": "os/microsoft",
        "label": "Microsoft",
        "level": "Vendor/Product",
        "parentId": "os",
        "parentLevel": "Technology",
        "childrenIds": [
          "os/microsoft/windows_10"
        ]
      },
      "switch/cisco": {
        "id": "switch/cisco",
        "label": "Cisco",
        "level": "Vendor/Product",
        "parentId": "switch",
        "parentLevel": "Technology",
        "childrenIds": [
          "switch/cisco/general"
        ]
      },
      "router/cisco": {
        "id": "router/cisco",
        "label": "Cisco",
        "level": "Vendor/Product",
        "parentId": "router",
        "parentLevel": "Technology",
        "childrenIds": [
          "router/cisco/general"
        ]
      },
      "o365/exchange": {
        "id": "o365/exchange",
        "label": "Exchange",
        "level": "Vendor/Product",
        "parentId": "o365",
        "parentLevel": "Technology",
        "childrenIds": [
          "o365/exchange/mgmt",
          "o365/exchange/graph",
          "o365/exchange/general"
        ]
      },
      "o365/onedrive": {
        "id": "o365/onedrive",
        "label": "Onedrive",
        "level": "Vendor/Product",
        "parentId": "o365",
        "parentLevel": "Technology",
        "childrenIds": [
          "o365/onedrive/general"
        ]
      },
      "o365/sharepoint": {
        "id": "o365/sharepoint",
        "label": "SharePoint",
        "level": "Vendor/Product",
        "parentId": "o365",
        "parentLevel": "Technology",
        "childrenIds": [
          "o365/sharepoint/general"
        ]
      },
      "firewall/fortinet/fortigate": {
        "id": "firewall/fortinet/fortigate",
        "label": "Fortigate",
        "level": "Model / Device Name",
        "parentId": "firewall/fortinet",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "firewall/fortinet/fortigate/traffic"
        ]
      },
      "firewall/fortinet/fw1": {
        "id": "firewall/fortinet/fw1",
        "label": "FW1",
        "level": "Model / Device Name",
        "parentId": "firewall/fortinet",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic"
        ]
      },
      "firewall/fortinet/general": {
        "id": "firewall/fortinet/general",
        "label": "General",
        "level": "Model / Device Name",
        "parentId": "firewall/fortinet",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "firewall/fortinet/general/events",
          "firewall/fortinet/general/system"
        ]
      },
      "firewall/paloalto/general": {
        "id": "firewall/paloalto/general",
        "label": "General",
        "level": "Model / Device Name",
        "parentId": "firewall/paloalto",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "firewall/paloalto/general/traffic",
          "firewall/paloalto/general/system"
        ]
      },
      "os/microsoft/windows_10": {
        "id": "os/microsoft/windows_10",
        "label": "Windows 10",
        "level": "Model / Device Name",
        "parentId": "os/microsoft",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "os/microsoft/windows_10/general"
        ]
      },
      "switch/cisco/general": {
        "id": "switch/cisco/general",
        "label": "General",
        "level": "Model / Device Name",
        "parentId": "switch/cisco",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "switch/cisco/general/general"
        ]
      },
      "router/cisco/general": {
        "id": "router/cisco/general",
        "label": "General",
        "level": "Model / Device Name",
        "parentId": "router/cisco",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "router/cisco/general/general"
        ]
      },
      "o365/exchange/mgmt": {
        "id": "o365/exchange/mgmt",
        "label": "Mgmt",
        "level": "Model / Device Name",
        "parentId": "o365/exchange",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "o365/exchange/mgmt/admin"
        ]
      },
      "o365/exchange/graph": {
        "id": "o365/exchange/graph",
        "label": "Graph",
        "level": "Model / Device Name",
        "parentId": "o365/exchange",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "o365/exchange/graph/system"
        ]
      },
      "o365/exchange/general": {
        "id": "o365/exchange/general",
        "label": "General",
        "level": "Model / Device Name",
        "parentId": "o365/exchange",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "o365/exchange/general/user"
        ]
      },
      "o365/onedrive/general": {
        "id": "o365/onedrive/general",
        "label": "General",
        "level": "Model / Device Name",
        "parentId": "o365/onedrive",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "o365/onedrive/general/user"
        ]
      },
      "o365/sharepoint/general": {
        "id": "o365/sharepoint/general",
        "label": "General",
        "level": "Model / Device Name",
        "parentId": "o365/sharepoint",
        "parentLevel": "Vendor/Product",
        "childrenIds": [
          "o365/sharepoint/general/user"
        ]
      },
      "firewall/fortinet/fortigate/traffic": {
        "id": "firewall/fortinet/fortigate/traffic",
        "label": "Traffic",
        "level": "Event Class",
        "parentId": "firewall/fortinet/fortigate",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "firewall/fortinet/fortigate/traffic/all"
        ]
      },
      "firewall/fortinet/fw1/traffic": {
        "id": "firewall/fortinet/fw1/traffic",
        "label": "Traffic",
        "level": "Event Class",
        "parentId": "firewall/fortinet/fw1",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/lan_dmz",
          "firewall/fortinet/fw1/traffic/lan_dc",
          "firewall/fortinet/fw1/traffic/dmz_lan",
          "firewall/fortinet/fw1/traffic/dc_lan",
          "firewall/fortinet/fw1/traffic/lan_public",
          "firewall/fortinet/fw1/traffic/dmz_public",
          "firewall/fortinet/fw1/traffic/dc_public",
          "firewall/fortinet/fw1/traffic/public_lan",
          "firewall/fortinet/fw1/traffic/public_dmz",
          "firewall/fortinet/fw1/traffic/public_dc"
        ]
      },
      "firewall/fortinet/general/events": {
        "id": "firewall/fortinet/general/events",
        "label": "Events",
        "level": "Event Class",
        "parentId": "firewall/fortinet/general",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "firewall/fortinet/general/events/all"
        ]
      },
      "firewall/fortinet/general/system": {
        "id": "firewall/fortinet/general/system",
        "label": "System",
        "level": "Event Class",
        "parentId": "firewall/fortinet/general",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "firewall/fortinet/general/system/all"
        ]
      },
      "firewall/paloalto/general/traffic": {
        "id": "firewall/paloalto/general/traffic",
        "label": "Traffic",
        "level": "Event Class",
        "parentId": "firewall/paloalto/general",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "firewall/paloalto/general/traffic/lan_dmz",
          "firewall/paloalto/general/traffic/lan_dc",
          "firewall/paloalto/general/traffic/dmz_lan",
          "firewall/paloalto/general/traffic/dc_lan",
          "firewall/paloalto/general/traffic/lan_public",
          "firewall/paloalto/general/traffic/dmz_public",
          "firewall/paloalto/general/traffic/dc_public",
          "firewall/paloalto/general/traffic/public_lan",
          "firewall/paloalto/general/traffic/public_dmz",
          "firewall/paloalto/general/traffic/public_dc"
        ]
      },
      "firewall/paloalto/general/system": {
        "id": "firewall/paloalto/general/system",
        "label": "System",
        "level": "Event Class",
        "parentId": "firewall/paloalto/general",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "firewall/paloalto/general/system/all"
        ]
      },
      "os/microsoft/windows_10/general": {
        "id": "os/microsoft/windows_10/general",
        "label": "General",
        "level": "Event Class",
        "parentId": "os/microsoft/windows_10",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "os/microsoft/windows_10/general/account_logon",
          "os/microsoft/windows_10/general/account_mgmt",
          "os/microsoft/windows_10/general/logon_logoff",
          "os/microsoft/windows_10/general/ds_access",
          "os/microsoft/windows_10/general/policy_change",
          "os/microsoft/windows_10/general/object_access",
          "os/microsoft/windows_10/general/system",
          "os/microsoft/windows_10/general/privilege_use",
          "os/microsoft/windows_10/general/detailed_tracking"
        ]
      },
      "switch/cisco/general/general": {
        "id": "switch/cisco/general/general",
        "label": "General",
        "level": "Event Class",
        "parentId": "switch/cisco/general",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "switch/cisco/general/general/all"
        ]
      },
      "router/cisco/general/general": {
        "id": "router/cisco/general/general",
        "label": "General",
        "level": "Event Class",
        "parentId": "router/cisco/general",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "router/cisco/general/general/all"
        ]
      },
      "o365/exchange/mgmt/admin": {
        "id": "o365/exchange/mgmt/admin",
        "label": "Admin",
        "level": "Event Class",
        "parentId": "o365/exchange/mgmt",
        "parentLevel": "Model / Device Name",
        "childrenIds": []
      },
      "o365/exchange/graph/system": {
        "id": "o365/exchange/graph/system",
        "label": "System",
        "level": "Event Class",
        "parentId": "o365/exchange/graph",
        "parentLevel": "Model / Device Name",
        "childrenIds": []
      },
      "o365/exchange/general/user": {
        "id": "o365/exchange/general/user",
        "label": "User",
        "level": "Event Class",
        "parentId": "o365/exchange/general",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "o365/exchange/general/user/accessed_mailbox_attachments",
          "o365/exchange/general/user/accessed_mailbox_folder",
          "o365/exchange/general/user/accessed_mailbox_items",
          "o365/exchange/general/user/accessed_message",
          "o365/exchange/general/user/added_delegate_permissions",
          "o365/exchange/general/user/add_remove_user_delegate",
          "o365/exchange/general/user/added_permissions_folder",
          "o365/exchange/general/user/copied_messages",
          "o365/exchange/general/user/created_mailbox_item",
          "o365/exchange/general/user/created_new_inbox_rule",
          "o365/exchange/general/user/delete_priority_cleanup",
          "o365/exchange/general/user/deleted_messages",
          "o365/exchange/general/user/label_message_record",
          "o365/exchange/general/user/labeled_item_record",
          "o365/exchange/general/user/modified_folder_permission",
          "o365/exchange/general/user/modified_inbox_rule",
          "o365/exchange/general/user/moved_messages",
          "o365/exchange/general/user/moved_messages_deleted",
          "o365/exchange/general/user/perform_search_query",
          "o365/exchange/general/user/preserve_mailbox_item",
          "o365/exchange/general/user/priority_cleanup_applied",
          "o365/exchange/general/user/purged_messages",
          "o365/exchange/general/user/removed_delegate_permissions",
          "o365/exchange/general/user/removed_permissions_folder",
          "o365/exchange/general/user/search_items_mailbox",
          "o365/exchange/general/user/sent_message",
          "o365/exchange/general/user/sent_message_send_as",
          "o365/exchange/general/user/sent_message_on_behalf",
          "o365/exchange/general/user/update_item_label",
          "o365/exchange/general/user/updated_inbox_rules",
          "o365/exchange/general/user/updated_message",
          "o365/exchange/general/user/user_signed_in"
        ]
      },
      "o365/onedrive/general/user": {
        "id": "o365/onedrive/general/user",
        "label": "User",
        "level": "Event Class",
        "parentId": "o365/onedrive/general",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "o365/onedrive/general/user/file_accessed",
          "o365/onedrive/general/user/file_modified",
          "o365/onedrive/general/user/file_previewed",
          "o365/onedrive/general/user/page_prefetched",
          "o365/onedrive/general/user/page_viewed",
          "o365/onedrive/general/user/accessed_file",
          "o365/onedrive/general/user/checked_in_file",
          "o365/onedrive/general/user/checked_out_file",
          "o365/onedrive/general/user/copied_file",
          "o365/onedrive/general/user/deleted_file",
          "o365/onedrive/general/user/downloaded_file",
          "o365/onedrive/general/user/modified_file",
          "o365/onedrive/general/user/moved_file",
          "o365/onedrive/general/user/uploaded_file",
          "o365/onedrive/general/user/renamed_file",
          "o365/onedrive/general/user/restored_file"
        ]
      },
      "o365/sharepoint/general/user": {
        "id": "o365/sharepoint/general/user",
        "label": "User",
        "level": "Event Class",
        "parentId": "o365/sharepoint/general",
        "parentLevel": "Model / Device Name",
        "childrenIds": [
          "o365/sharepoint/general/user/file_accessed",
          "o365/sharepoint/general/user/file_modified",
          "o365/sharepoint/general/user/file_previewed",
          "o365/sharepoint/general/user/page_prefetched",
          "o365/sharepoint/general/user/page_viewed",
          "o365/sharepoint/general/user/accessed_file",
          "o365/sharepoint/general/user/checked_in_file",
          "o365/sharepoint/general/user/checked_out_file",
          "o365/sharepoint/general/user/copied_file",
          "o365/sharepoint/general/user/deleted_file",
          "o365/sharepoint/general/user/downloaded_file",
          "o365/sharepoint/general/user/modified_file",
          "o365/sharepoint/general/user/moved_file",
          "o365/sharepoint/general/user/uploaded_file",
          "o365/sharepoint/general/user/renamed_file",
          "o365/sharepoint/general/user/restored_file"
        ]
      },
      "firewall/fortinet/fortigate/traffic/all": {
        "id": "firewall/fortinet/fortigate/traffic/all",
        "label": "All",
        "level": "Type",
        "parentId": "firewall/fortinet/fortigate/traffic",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/lan_dmz": {
        "id": "firewall/fortinet/fw1/traffic/lan_dmz",
        "label": "LAN - DMZ",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/lan_dmz/allow",
          "firewall/fortinet/fw1/traffic/lan_dmz/deny"
        ]
      },
      "firewall/fortinet/fw1/traffic/lan_dc": {
        "id": "firewall/fortinet/fw1/traffic/lan_dc",
        "label": "LAN - DC",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/lan_dc/allow",
          "firewall/fortinet/fw1/traffic/lan_dc/deny"
        ]
      },
      "firewall/fortinet/fw1/traffic/dmz_lan": {
        "id": "firewall/fortinet/fw1/traffic/dmz_lan",
        "label": "DMZ - LAN",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/dmz_lan/allow",
          "firewall/fortinet/fw1/traffic/dmz_lan/deny"
        ]
      },
      "firewall/fortinet/fw1/traffic/dc_lan": {
        "id": "firewall/fortinet/fw1/traffic/dc_lan",
        "label": "DC - LAN",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/dc_lan/allow",
          "firewall/fortinet/fw1/traffic/dc_lan/deny"
        ]
      },
      "firewall/fortinet/fw1/traffic/lan_public": {
        "id": "firewall/fortinet/fw1/traffic/lan_public",
        "label": "LAN - Public",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/lan_public/allow",
          "firewall/fortinet/fw1/traffic/lan_public/deny"
        ]
      },
      "firewall/fortinet/fw1/traffic/dmz_public": {
        "id": "firewall/fortinet/fw1/traffic/dmz_public",
        "label": "DMZ - Public",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/dmz_public/allow",
          "firewall/fortinet/fw1/traffic/dmz_public/deny"
        ]
      },
      "firewall/fortinet/fw1/traffic/dc_public": {
        "id": "firewall/fortinet/fw1/traffic/dc_public",
        "label": "DC - Public",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/dc_public/allow",
          "firewall/fortinet/fw1/traffic/dc_public/deny"
        ]
      },
      "firewall/fortinet/fw1/traffic/public_lan": {
        "id": "firewall/fortinet/fw1/traffic/public_lan",
        "label": "Public - LAN",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/public_lan/allow",
          "firewall/fortinet/fw1/traffic/public_lan/deny"
        ]
      },
      "firewall/fortinet/fw1/traffic/public_dmz": {
        "id": "firewall/fortinet/fw1/traffic/public_dmz",
        "label": "Public - DMZ",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/public_dmz/allow",
          "firewall/fortinet/fw1/traffic/public_dmz/deny"
        ]
      },
      "firewall/fortinet/fw1/traffic/public_dc": {
        "id": "firewall/fortinet/fw1/traffic/public_dc",
        "label": "Public - DC",
        "level": "Type",
        "parentId": "firewall/fortinet/fw1/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/fortinet/fw1/traffic/public_dc/allow",
          "firewall/fortinet/fw1/traffic/public_dc/deny"
        ]
      },
      "firewall/fortinet/general/events/all": {
        "id": "firewall/fortinet/general/events/all",
        "label": "All",
        "level": "Type",
        "parentId": "firewall/fortinet/general/events",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "firewall/fortinet/general/system/all": {
        "id": "firewall/fortinet/general/system/all",
        "label": "All",
        "level": "Type",
        "parentId": "firewall/fortinet/general/system",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/lan_dmz": {
        "id": "firewall/paloalto/general/traffic/lan_dmz",
        "label": "LAN - DMZ",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/lan_dmz/allow",
          "firewall/paloalto/general/traffic/lan_dmz/deny"
        ]
      },
      "firewall/paloalto/general/traffic/lan_dc": {
        "id": "firewall/paloalto/general/traffic/lan_dc",
        "label": "LAN - DC",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/lan_dc/allow",
          "firewall/paloalto/general/traffic/lan_dc/deny"
        ]
      },
      "firewall/paloalto/general/traffic/dmz_lan": {
        "id": "firewall/paloalto/general/traffic/dmz_lan",
        "label": "DMZ - LAN",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/dmz_lan/allow",
          "firewall/paloalto/general/traffic/dmz_lan/deny"
        ]
      },
      "firewall/paloalto/general/traffic/dc_lan": {
        "id": "firewall/paloalto/general/traffic/dc_lan",
        "label": "DC - LAN",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/dc_lan/allow",
          "firewall/paloalto/general/traffic/dc_lan/deny"
        ]
      },
      "firewall/paloalto/general/traffic/lan_public": {
        "id": "firewall/paloalto/general/traffic/lan_public",
        "label": "LAN - Public",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/lan_public/allow",
          "firewall/paloalto/general/traffic/lan_public/deny"
        ]
      },
      "firewall/paloalto/general/traffic/dmz_public": {
        "id": "firewall/paloalto/general/traffic/dmz_public",
        "label": "DMZ - Public",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/dmz_public/allow",
          "firewall/paloalto/general/traffic/dmz_public/deny"
        ]
      },
      "firewall/paloalto/general/traffic/dc_public": {
        "id": "firewall/paloalto/general/traffic/dc_public",
        "label": "DC - Public",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/dc_public/allow",
          "firewall/paloalto/general/traffic/dc_public/deny"
        ]
      },
      "firewall/paloalto/general/traffic/public_lan": {
        "id": "firewall/paloalto/general/traffic/public_lan",
        "label": "Public - LAN",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/public_lan/allow",
          "firewall/paloalto/general/traffic/public_lan/deny"
        ]
      },
      "firewall/paloalto/general/traffic/public_dmz": {
        "id": "firewall/paloalto/general/traffic/public_dmz",
        "label": "Public - DMZ",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/public_dmz/allow",
          "firewall/paloalto/general/traffic/public_dmz/deny"
        ]
      },
      "firewall/paloalto/general/traffic/public_dc": {
        "id": "firewall/paloalto/general/traffic/public_dc",
        "label": "Public - DC",
        "level": "Type",
        "parentId": "firewall/paloalto/general/traffic",
        "parentLevel": "Event Class",
        "childrenIds": [
          "firewall/paloalto/general/traffic/public_dc/allow",
          "firewall/paloalto/general/traffic/public_dc/deny"
        ]
      },
      "firewall/paloalto/general/system/all": {
        "id": "firewall/paloalto/general/system/all",
        "label": "All",
        "level": "Type",
        "parentId": "firewall/paloalto/general/system",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "os/microsoft/windows_10/general/account_logon": {
        "id": "os/microsoft/windows_10/general/account_logon",
        "label": "Account Logon",
        "level": "Type",
        "parentId": "os/microsoft/windows_10/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "os/microsoft/windows_10/general/account_mgmt": {
        "id": "os/microsoft/windows_10/general/account_mgmt",
        "label": "Account Mgmt",
        "level": "Type",
        "parentId": "os/microsoft/windows_10/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "os/microsoft/windows_10/general/logon_logoff": {
        "id": "os/microsoft/windows_10/general/logon_logoff",
        "label": "Logon - Logoff",
        "level": "Type",
        "parentId": "os/microsoft/windows_10/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "os/microsoft/windows_10/general/ds_access": {
        "id": "os/microsoft/windows_10/general/ds_access",
        "label": "DS Access",
        "level": "Type",
        "parentId": "os/microsoft/windows_10/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "os/microsoft/windows_10/general/policy_change": {
        "id": "os/microsoft/windows_10/general/policy_change",
        "label": "Policy Change",
        "level": "Type",
        "parentId": "os/microsoft/windows_10/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "os/microsoft/windows_10/general/object_access": {
        "id": "os/microsoft/windows_10/general/object_access",
        "label": "Object Access",
        "level": "Type",
        "parentId": "os/microsoft/windows_10/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "os/microsoft/windows_10/general/system": {
        "id": "os/microsoft/windows_10/general/system",
        "label": "System",
        "level": "Type",
        "parentId": "os/microsoft/windows_10/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "os/microsoft/windows_10/general/privilege_use": {
        "id": "os/microsoft/windows_10/general/privilege_use",
        "label": "Privilege Use",
        "level": "Type",
        "parentId": "os/microsoft/windows_10/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "os/microsoft/windows_10/general/detailed_tracking": {
        "id": "os/microsoft/windows_10/general/detailed_tracking",
        "label": "Detailed Tracking",
        "level": "Type",
        "parentId": "os/microsoft/windows_10/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "switch/cisco/general/general/all": {
        "id": "switch/cisco/general/general/all",
        "label": "All",
        "level": "Type",
        "parentId": "switch/cisco/general/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "router/cisco/general/general/all": {
        "id": "router/cisco/general/general/all",
        "label": "All",
        "level": "Type",
        "parentId": "router/cisco/general/general",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/accessed_mailbox_attachments": {
        "id": "o365/exchange/general/user/accessed_mailbox_attachments",
        "label": "Accessed mailbox attachments",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/accessed_mailbox_folder": {
        "id": "o365/exchange/general/user/accessed_mailbox_folder",
        "label": "Accessed Mailbox folder",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/accessed_mailbox_items": {
        "id": "o365/exchange/general/user/accessed_mailbox_items",
        "label": "Accessed mailbox items",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/accessed_message": {
        "id": "o365/exchange/general/user/accessed_message",
        "label": "Accessed message",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/added_delegate_permissions": {
        "id": "o365/exchange/general/user/added_delegate_permissions",
        "label": "Added delegate mailbox permissions",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/add_remove_user_delegate": {
        "id": "o365/exchange/general/user/add_remove_user_delegate",
        "label": "Add - remove user with delegate to calendar",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/added_permissions_folder": {
        "id": "o365/exchange/general/user/added_permissions_folder",
        "label": "Added permissions to folder",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/copied_messages": {
        "id": "o365/exchange/general/user/copied_messages",
        "label": "Copied messages to another folder",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/created_mailbox_item": {
        "id": "o365/exchange/general/user/created_mailbox_item",
        "label": "Created mailbox item",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/created_new_inbox_rule": {
        "id": "o365/exchange/general/user/created_new_inbox_rule",
        "label": "Created new inbox rule in Outlook web app",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/delete_priority_cleanup": {
        "id": "o365/exchange/general/user/delete_priority_cleanup",
        "label": "Delete priority cleanup label item",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/deleted_messages": {
        "id": "o365/exchange/general/user/deleted_messages",
        "label": "Deleted messages from Deleted Items folder",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/label_message_record": {
        "id": "o365/exchange/general/user/label_message_record",
        "label": "Label message as a record",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/labeled_item_record": {
        "id": "o365/exchange/general/user/labeled_item_record",
        "label": "Labeled item as a record",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/modified_folder_permission": {
        "id": "o365/exchange/general/user/modified_folder_permission",
        "label": "Modified folder permission",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/modified_inbox_rule": {
        "id": "o365/exchange/general/user/modified_inbox_rule",
        "label": "Modified inbox rule from Outlook web app",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/moved_messages": {
        "id": "o365/exchange/general/user/moved_messages",
        "label": "Moved messages to another folder",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/moved_messages_deleted": {
        "id": "o365/exchange/general/user/moved_messages_deleted",
        "label": "Moved messages to Deleted Items folder",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/perform_search_query": {
        "id": "o365/exchange/general/user/perform_search_query",
        "label": "Perform search query",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/preserve_mailbox_item": {
        "id": "o365/exchange/general/user/preserve_mailbox_item",
        "label": "Preserve Mailbox Item",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/priority_cleanup_applied": {
        "id": "o365/exchange/general/user/priority_cleanup_applied",
        "label": "Priority cleanup label applied",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/purged_messages": {
        "id": "o365/exchange/general/user/purged_messages",
        "label": "Purged messages from the mailbox",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/removed_delegate_permissions": {
        "id": "o365/exchange/general/user/removed_delegate_permissions",
        "label": "Removed delegate mailbox permissions",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/removed_permissions_folder": {
        "id": "o365/exchange/general/user/removed_permissions_folder",
        "label": "Removed permissions from folder",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/search_items_mailbox": {
        "id": "o365/exchange/general/user/search_items_mailbox",
        "label": "Search items in a mailbox",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/sent_message": {
        "id": "o365/exchange/general/user/sent_message",
        "label": "Sent message",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/sent_message_send_as": {
        "id": "o365/exchange/general/user/sent_message_send_as",
        "label": "Sent message using Send As permissions",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/sent_message_on_behalf": {
        "id": "o365/exchange/general/user/sent_message_on_behalf",
        "label": "Sent message using On Behalf permissions",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/update_item_label": {
        "id": "o365/exchange/general/user/update_item_label",
        "label": "Update item label",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/updated_inbox_rules": {
        "id": "o365/exchange/general/user/updated_inbox_rules",
        "label": "Updated inbox rules from Outlook client",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/updated_message": {
        "id": "o365/exchange/general/user/updated_message",
        "label": "Updated message",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/exchange/general/user/user_signed_in": {
        "id": "o365/exchange/general/user/user_signed_in",
        "label": "User signed in to mailbox",
        "level": "Type",
        "parentId": "o365/exchange/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/file_accessed": {
        "id": "o365/onedrive/general/user/file_accessed",
        "label": "FileAccessedExtended",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/file_modified": {
        "id": "o365/onedrive/general/user/file_modified",
        "label": "FileModifiedExtended",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/file_previewed": {
        "id": "o365/onedrive/general/user/file_previewed",
        "label": "FilePreviewed",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/page_prefetched": {
        "id": "o365/onedrive/general/user/page_prefetched",
        "label": "PagePrefetched",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/page_viewed": {
        "id": "o365/onedrive/general/user/page_viewed",
        "label": "PageViewedExtended",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/accessed_file": {
        "id": "o365/onedrive/general/user/accessed_file",
        "label": "Accessed file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/checked_in_file": {
        "id": "o365/onedrive/general/user/checked_in_file",
        "label": "Checked in file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/checked_out_file": {
        "id": "o365/onedrive/general/user/checked_out_file",
        "label": "Checked out file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/copied_file": {
        "id": "o365/onedrive/general/user/copied_file",
        "label": "Copied file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/deleted_file": {
        "id": "o365/onedrive/general/user/deleted_file",
        "label": "Deleted file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/downloaded_file": {
        "id": "o365/onedrive/general/user/downloaded_file",
        "label": "Downloaded file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/modified_file": {
        "id": "o365/onedrive/general/user/modified_file",
        "label": "Modified file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/moved_file": {
        "id": "o365/onedrive/general/user/moved_file",
        "label": "Moved file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/uploaded_file": {
        "id": "o365/onedrive/general/user/uploaded_file",
        "label": "Uploaded file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/renamed_file": {
        "id": "o365/onedrive/general/user/renamed_file",
        "label": "Renamed file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/onedrive/general/user/restored_file": {
        "id": "o365/onedrive/general/user/restored_file",
        "label": "Restored file",
        "level": "Type",
        "parentId": "o365/onedrive/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/file_accessed": {
        "id": "o365/sharepoint/general/user/file_accessed",
        "label": "FileAccessedExtended",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/file_modified": {
        "id": "o365/sharepoint/general/user/file_modified",
        "label": "FileModifiedExtended",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/file_previewed": {
        "id": "o365/sharepoint/general/user/file_previewed",
        "label": "FilePreviewed",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/page_prefetched": {
        "id": "o365/sharepoint/general/user/page_prefetched",
        "label": "PagePrefetched",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/page_viewed": {
        "id": "o365/sharepoint/general/user/page_viewed",
        "label": "PageViewedExtended",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/accessed_file": {
        "id": "o365/sharepoint/general/user/accessed_file",
        "label": "Accessed file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/checked_in_file": {
        "id": "o365/sharepoint/general/user/checked_in_file",
        "label": "Checked in file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/checked_out_file": {
        "id": "o365/sharepoint/general/user/checked_out_file",
        "label": "Checked out file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/copied_file": {
        "id": "o365/sharepoint/general/user/copied_file",
        "label": "Copied file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/deleted_file": {
        "id": "o365/sharepoint/general/user/deleted_file",
        "label": "Deleted file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/downloaded_file": {
        "id": "o365/sharepoint/general/user/downloaded_file",
        "label": "Downloaded file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/modified_file": {
        "id": "o365/sharepoint/general/user/modified_file",
        "label": "Modified file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/moved_file": {
        "id": "o365/sharepoint/general/user/moved_file",
        "label": "Moved file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/uploaded_file": {
        "id": "o365/sharepoint/general/user/uploaded_file",
        "label": "Uploaded file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/renamed_file": {
        "id": "o365/sharepoint/general/user/renamed_file",
        "label": "Renamed file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "o365/sharepoint/general/user/restored_file": {
        "id": "o365/sharepoint/general/user/restored_file",
        "label": "Restored file",
        "level": "Type",
        "parentId": "o365/sharepoint/general/user",
        "parentLevel": "Event Class",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/lan_dmz/allow": {
        "id": "firewall/fortinet/fw1/traffic/lan_dmz/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/lan_dmz",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/lan_dmz/deny": {
        "id": "firewall/fortinet/fw1/traffic/lan_dmz/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/lan_dmz",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/lan_dc/allow": {
        "id": "firewall/fortinet/fw1/traffic/lan_dc/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/lan_dc",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/lan_dc/deny": {
        "id": "firewall/fortinet/fw1/traffic/lan_dc/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/lan_dc",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/dmz_lan/allow": {
        "id": "firewall/fortinet/fw1/traffic/dmz_lan/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/dmz_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/dmz_lan/deny": {
        "id": "firewall/fortinet/fw1/traffic/dmz_lan/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/dmz_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/dc_lan/allow": {
        "id": "firewall/fortinet/fw1/traffic/dc_lan/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/dc_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/dc_lan/deny": {
        "id": "firewall/fortinet/fw1/traffic/dc_lan/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/dc_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/lan_public/allow": {
        "id": "firewall/fortinet/fw1/traffic/lan_public/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/lan_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/lan_public/deny": {
        "id": "firewall/fortinet/fw1/traffic/lan_public/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/lan_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/dmz_public/allow": {
        "id": "firewall/fortinet/fw1/traffic/dmz_public/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/dmz_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/dmz_public/deny": {
        "id": "firewall/fortinet/fw1/traffic/dmz_public/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/dmz_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/dc_public/allow": {
        "id": "firewall/fortinet/fw1/traffic/dc_public/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/dc_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/dc_public/deny": {
        "id": "firewall/fortinet/fw1/traffic/dc_public/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/dc_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/public_lan/allow": {
        "id": "firewall/fortinet/fw1/traffic/public_lan/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/public_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/public_lan/deny": {
        "id": "firewall/fortinet/fw1/traffic/public_lan/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/public_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/public_dmz/allow": {
        "id": "firewall/fortinet/fw1/traffic/public_dmz/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/public_dmz",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/public_dmz/deny": {
        "id": "firewall/fortinet/fw1/traffic/public_dmz/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/public_dmz",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/public_dc/allow": {
        "id": "firewall/fortinet/fw1/traffic/public_dc/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/public_dc",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/fortinet/fw1/traffic/public_dc/deny": {
        "id": "firewall/fortinet/fw1/traffic/public_dc/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/fortinet/fw1/traffic/public_dc",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/lan_dmz/allow": {
        "id": "firewall/paloalto/general/traffic/lan_dmz/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/lan_dmz",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/lan_dmz/deny": {
        "id": "firewall/paloalto/general/traffic/lan_dmz/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/lan_dmz",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/lan_dc/allow": {
        "id": "firewall/paloalto/general/traffic/lan_dc/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/lan_dc",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/lan_dc/deny": {
        "id": "firewall/paloalto/general/traffic/lan_dc/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/lan_dc",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/dmz_lan/allow": {
        "id": "firewall/paloalto/general/traffic/dmz_lan/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/dmz_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/dmz_lan/deny": {
        "id": "firewall/paloalto/general/traffic/dmz_lan/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/dmz_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/dc_lan/allow": {
        "id": "firewall/paloalto/general/traffic/dc_lan/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/dc_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/dc_lan/deny": {
        "id": "firewall/paloalto/general/traffic/dc_lan/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/dc_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/lan_public/allow": {
        "id": "firewall/paloalto/general/traffic/lan_public/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/lan_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/lan_public/deny": {
        "id": "firewall/paloalto/general/traffic/lan_public/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/lan_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/dmz_public/allow": {
        "id": "firewall/paloalto/general/traffic/dmz_public/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/dmz_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/dmz_public/deny": {
        "id": "firewall/paloalto/general/traffic/dmz_public/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/dmz_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/dc_public/allow": {
        "id": "firewall/paloalto/general/traffic/dc_public/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/dc_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/dc_public/deny": {
        "id": "firewall/paloalto/general/traffic/dc_public/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/dc_public",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/public_lan/allow": {
        "id": "firewall/paloalto/general/traffic/public_lan/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/public_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/public_lan/deny": {
        "id": "firewall/paloalto/general/traffic/public_lan/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/public_lan",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/public_dmz/allow": {
        "id": "firewall/paloalto/general/traffic/public_dmz/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/public_dmz",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/public_dmz/deny": {
        "id": "firewall/paloalto/general/traffic/public_dmz/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/public_dmz",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/public_dc/allow": {
        "id": "firewall/paloalto/general/traffic/public_dc/allow",
        "label": "Allow",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/public_dc",
        "parentLevel": "Type",
        "childrenIds": []
      },
      "firewall/paloalto/general/traffic/public_dc/deny": {
        "id": "firewall/paloalto/general/traffic/public_dc/deny",
        "label": "Deny",
        "level": "Subtype",
        "parentId": "firewall/paloalto/general/traffic/public_dc",
        "parentLevel": "Type",
        "childrenIds": []
      }
    }
  }
  
  
  

  structure={}

  defaultStructure={}


  display = "";
  timeControler;
  timerState: boolean = false;
  errorMessage;
  qtnList;
  forgotPwdmetaData;
  newPwdmetaData;
  strongPassword: boolean;
  forgotPwdState: number = 0;
  showPass1: boolean;
  showPass2: boolean;
  showForgotError: boolean = false;
  showNewPassError: boolean = false;
  $destroy: Subject<boolean> = new Subject();
  mat_spinner_forgotpwd_state: boolean;
  validationData: any = { "password": { "minlength": 8, "maxlength": 30 }, "secret_ques": { "minlength": 3, "maxlength": 50 } };


  //form contols for loginForm
  loginForm = this.fb.group({
    userName: ["", [Validators.required]],
    pwd: ["", [Validators.required]],
  })

  force_login: boolean = false;

  //form contols for pwdVerifyQuestion
  pwdVerify = this.fb.group({
    user_name: [],
    ans1: ['', [Validators.required, Validators.maxLength(this.validationData.secret_ques.maxlength), Validators.minLength(this.validationData.minlength)]],
    ans2: ['', [Validators.required, Validators.maxLength(this.validationData.secret_ques.maxlength), Validators.minLength(this.validationData.minlength)]],
    verificationCode: ['', [Validators.required, Validators.maxLength(4), Validators.minLength(4)]]

  })
  setPwd: UntypedFormGroup;

   margin = {
    top: 20,
    right: 20,
    bottom: 45,
    left: 55
};

sample_chart ={
  "title": "Day wise alerts count",
  "subtitle": "Past 30 days ( 25 May - 23 Jun )",
  "type": "line_chart",
  "style": {
      "axes": {
          "x-axis": {
              "name": null,
              "enable": null,
              "position": null,
              "font-size": null
          },
          "y-axis": {
              "name": null,
              "enable": null,
              "position": null,
              "font-size": null
          }
      },
      "legend": {
          "icon": null,
          "type": null,
          "enable": null
      },
      "compact": {
          "mode": "auto",
          "type": "number"
      },
      "table_body": {
          "font-size": null,
          "background-color": null
      },
      "table_header": {
          "enable": null,
          "font-size": null,
          "text-align": null,
          "background-color": null
      },
      "widget_title": "Day wise alerts count",
      "color_palette": [
          "#d0648a",
          "#57a79c",
          "#f58db2",
          "#f2b3c9",
          "#22c3aa",
          "#7bd9a5",
          "#8a39ac",
          "#b56cd1",
          "#56007a"
      ]
  },
  "widgetdata": {
      "rows": [
          {
              "dimension1": "1781980200",
              "metric1": 20184
          },
          {
              "dimension1": "1782066600",
              "metric1": 22333
          },
          {
              "dimension1": "1782153000",
              "metric1": 16923
          },
          {
              "dimension1": "1782239400",
              "metric1": 16618
          },
          {
              "dimension1": "1782325800",
              "metric1": 21314
          },
          {
              "dimension1": "1782412200",
              "metric1": 19300
          },
          {
              "dimension1": "1782498600",
              "metric1": 7905
          },
          {
              "dimension1": "1782585000",
              "metric1": 12510
          },
          {
              "dimension1": "1782757800",
              "metric1": 13858
          },
          {
              "dimension1": "1782844200",
              "metric1": 12467
          },
          {
              "dimension1": "1782930600",
              "metric1": 18774
          },
          {
              "dimension1": "1783017000",
              "metric1": 23313
          },
          {
              "dimension1": "1783103400",
              "metric1": 23107
          },
          {
              "dimension1": "1783189800",
              "metric1": 30772
          },
          {
              "dimension1": "1783276200",
              "metric1": 24660
          },
          {
              "dimension1": "1783362600",
              "metric1": 28290
          },
          {
              "dimension1": "1783449000",
              "metric1": 28742
          },
          {
              "dimension1": "1783535400",
              "metric1": 18577
          },
          {
              "dimension1": "1783621800",
              "metric1": 20247
          },
          {
              "dimension1": "1783708200",
              "metric1": 14084
          },
          {
              "dimension1": "1783794600",
              "metric1": 15702
          },
          {
              "dimension1": "1783881000",
              "metric1": 20972
          },
          {
              "dimension1": "1783967400",
              "metric1": 22531
          },
          {
              "dimension1": "1784053800",
              "metric1": 21612
          },
          {
              "dimension1": "1784140200",
              "metric1": 18856
          },
          {
              "dimension1": "1784226600",
              "metric1": 17724
          },
          {
              "dimension1": "1784313000",
              "metric1": 10808
          },
          {
              "dimension1": "1784399400",
              "metric1": 12301
          }
      ],
      "headers": [
          {
              "disp": "Time",
              "type": "timestamp",
              "value": "dimension1"
          },
          {
              "disp": "Sum AlertCount",
              "type": "number",
              "value": "metric1"
          }
      ]
  }
}

sample_area_stack={
  "title": "Event trends by source",
  "subtitle": "Past 30 days ( 12 May - 10 Jun )",
  "type": "area_stack",
  "style": {
      "axes": {
          "x-axis": {
              "name": "Day",
              "enable": true,
              "position": "middle",
              "font-size": "12"
          },
          "y-axis": {
              "name": "Event count",
              "enable": true,
              "position": "middle",
              "font-size": "12"
          }
      },
      "legend": {
          "icon": null,
          "type": null,
          "enable": null
      },
      "compact": {
          "mode": "auto",
          "type": "number"
      },
      "table_body": {
          "font-size": null,
          "background-color": null
      },
      "table_header": {
          "enable": null,
          "font-size": null,
          "text-align": null,
          "background-color": null
      },
      "widget_title": "Event trends by source",
      "color_palette": [
          "#61C2A2",
          "#4C7D60",
          "#2C8395",
          "#384960",
          "#A9BCB0",
          "#E88670",
          "#7fd6b8",
          "#3da9b8",
          "#5c6f87"
      ]
  },
  "widgetdata": {
      "rows": [
          {
              "dimension1": "1781980200",
              "dimension2": "Cisco Router",
              "metric1": 4227
          },
          {
              "dimension1": "1782066600",
              "dimension2": "Cisco Router",
              "metric1": 4879
          },
          {
              "dimension1": "1782153000",
              "dimension2": "Cisco Router",
              "metric1": 5275
          },
          {
              "dimension1": "1782239400",
              "dimension2": "Cisco Router",
              "metric1": 4212
          },
          {
              "dimension1": "1782325800",
              "dimension2": "Cisco Router",
              "metric1": 8351
          },
          {
              "dimension1": "1782412200",
              "dimension2": "Cisco Router",
              "metric1": 6972
          },
          {
              "dimension1": "1782498600",
              "dimension2": "Cisco Router",
              "metric1": 6565
          },
          {
              "dimension1": "1782585000",
              "dimension2": "Cisco Router",
              "metric1": 6380
          },
          {
              "dimension1": "1782671400",
              "dimension2": "Cisco Router",
              "metric1": 7313
          },
          {
              "dimension1": "1782757800",
              "dimension2": "Cisco Router",
              "metric1": 7840
          },
          {
              "dimension1": "1782844200",
              "dimension2": "Cisco Router",
              "metric1": 7853
          },
          {
              "dimension1": "1782930600",
              "dimension2": "Cisco Router",
              "metric1": 7317
          },
          {
              "dimension1": "1783017000",
              "dimension2": "Cisco Router",
              "metric1": 10203
          },
          {
              "dimension1": "1783103400",
              "dimension2": "Cisco Router",
              "metric1": 10222
          },
          {
              "dimension1": "1783189800",
              "dimension2": "Cisco Router",
              "metric1": 7854
          },
          {
              "dimension1": "1783276200",
              "dimension2": "Cisco Router",
              "metric1": 7166
          },
          {
              "dimension1": "1783362600",
              "dimension2": "Cisco Router",
              "metric1": 11673
          },
          {
              "dimension1": "1783449000",
              "dimension2": "Cisco Router",
              "metric1": 10403
          },
          {
              "dimension1": "1783535400",
              "dimension2": "Cisco Router",
              "metric1": 8203
          },
          {
              "dimension1": "1783621800",
              "dimension2": "Cisco Router",
              "metric1": 8184
          },
          {
              "dimension1": "1783708200",
              "dimension2": "Cisco Router",
              "metric1": 8131
          },
          {
              "dimension1": "1783794600",
              "dimension2": "Cisco Router",
              "metric1": 3475
          },
          {
              "dimension1": "1783881000",
              "dimension2": "Cisco Router",
              "metric1": 7040
          },
          {
              "dimension1": "1783967400",
              "dimension2": "Cisco Router",
              "metric1": 6745
          },
          {
              "dimension1": "1784053800",
              "dimension2": "Cisco Router",
              "metric1": 7727
          },
          {
              "dimension1": "1784140200",
              "dimension2": "Cisco Router",
              "metric1": 8429
          },
          {
              "dimension1": "1784226600",
              "dimension2": "Cisco Router",
              "metric1": 8863
          },
          {
              "dimension1": "1784313000",
              "dimension2": "Cisco Router",
              "metric1": 7890
          },
          {
              "dimension1": "1784399400",
              "dimension2": "Cisco Router",
              "metric1": 2378
          },
          {
              "dimension1": "1784485800",
              "dimension2": "Cisco Router",
              "metric1": 8639
          },
          {
              "dimension1": "1781980200",
              "dimension2": "Cisco Switch",
              "metric1": 21608
          },
          {
              "dimension1": "1782066600",
              "dimension2": "Cisco Switch",
              "metric1": 21502
          },
          {
              "dimension1": "1782153000",
              "dimension2": "Cisco Switch",
              "metric1": 21584
          },
          {
              "dimension1": "1782239400",
              "dimension2": "Cisco Switch",
              "metric1": 12732
          },
          {
              "dimension1": "1782325800",
              "dimension2": "Cisco Switch",
              "metric1": 21380
          },
          {
              "dimension1": "1782412200",
              "dimension2": "Cisco Switch",
              "metric1": 21648
          },
          {
              "dimension1": "1782498600",
              "dimension2": "Cisco Switch",
              "metric1": 37974
          },
          {
              "dimension1": "1782585000",
              "dimension2": "Cisco Switch",
              "metric1": 28472
          },
          {
              "dimension1": "1782671400",
              "dimension2": "Cisco Switch",
              "metric1": 21584
          },
          {
              "dimension1": "1782757800",
              "dimension2": "Cisco Switch",
              "metric1": 21556
          },
          {
              "dimension1": "1782844200",
              "dimension2": "Cisco Switch",
              "metric1": 21632
          },
          {
              "dimension1": "1782930600",
              "dimension2": "Cisco Switch",
              "metric1": 21588
          },
          {
              "dimension1": "1783017000",
              "dimension2": "Cisco Switch",
              "metric1": 21640
          },
          {
              "dimension1": "1783103400",
              "dimension2": "Cisco Switch",
              "metric1": 21564
          },
          {
              "dimension1": "1783189800",
              "dimension2": "Cisco Switch",
              "metric1": 19778
          },
          {
              "dimension1": "1783276200",
              "dimension2": "Cisco Switch",
              "metric1": 21500
          },
          {
              "dimension1": "1783362600",
              "dimension2": "Cisco Switch",
              "metric1": 21312
          },
          {
              "dimension1": "1783449000",
              "dimension2": "Cisco Switch",
              "metric1": 21298
          },
          {
              "dimension1": "1783535400",
              "dimension2": "Cisco Switch",
              "metric1": 19818
          },
          {
              "dimension1": "1783621800",
              "dimension2": "Cisco Switch",
              "metric1": 21963
          },
          {
              "dimension1": "1783708200",
              "dimension2": "Cisco Switch",
              "metric1": 19708
          },
          {
              "dimension1": "1783794600",
              "dimension2": "Cisco Switch",
              "metric1": 14143
          },
          {
              "dimension1": "1783881000",
              "dimension2": "Cisco Switch",
              "metric1": 22350
          },
          {
              "dimension1": "1783967400",
              "dimension2": "Cisco Switch",
              "metric1": 22554
          },
          {
              "dimension1": "1784053800",
              "dimension2": "Cisco Switch",
              "metric1": 22387
          },
          {
              "dimension1": "1784140200",
              "dimension2": "Cisco Switch",
              "metric1": 22547
          },
          {
              "dimension1": "1784226600",
              "dimension2": "Cisco Switch",
              "metric1": 22327
          },
          {
              "dimension1": "1784313000",
              "dimension2": "Cisco Switch",
              "metric1": 18506
          },
          {
              "dimension1": "1784399400",
              "dimension2": "Cisco Switch",
              "metric1": 9955
          },
          {
              "dimension1": "1784485800",
              "dimension2": "Cisco Switch",
              "metric1": 15771
          },
          {
              "dimension1": "1782066600",
              "dimension2": "Firepower",
              "metric1": 11405029
          },
          {
              "dimension1": "1782153000",
              "dimension2": "Firepower",
              "metric1": 45194789
          },
          {
              "dimension1": "1782239400",
              "dimension2": "Firepower",
              "metric1": 39520959
          },
          {
              "dimension1": "1782325800",
              "dimension2": "Firepower",
              "metric1": 120600250
          },
          {
              "dimension1": "1782412200",
              "dimension2": "Firepower",
              "metric1": 101903014
          },
          {
              "dimension1": "1782498600",
              "dimension2": "Firepower",
              "metric1": 156897670
          },
          {
              "dimension1": "1782585000",
              "dimension2": "Firepower",
              "metric1": 172192969
          },
          {
              "dimension1": "1782671400",
              "dimension2": "Firepower",
              "metric1": 203765368
          },
          {
              "dimension1": "1782757800",
              "dimension2": "Firepower",
              "metric1": 172739351
          },
          {
              "dimension1": "1782844200",
              "dimension2": "Firepower",
              "metric1": 182802568
          },
          {
              "dimension1": "1782930600",
              "dimension2": "Firepower",
              "metric1": 116274651
          },
          {
              "dimension1": "1783017000",
              "dimension2": "Firepower",
              "metric1": 116117596
          },
          {
              "dimension1": "1783103400",
              "dimension2": "Firepower",
              "metric1": 122843685
          },
          {
              "dimension1": "1783189800",
              "dimension2": "Firepower",
              "metric1": 66504232
          },
          {
              "dimension1": "1783276200",
              "dimension2": "Firepower",
              "metric1": 33387178
          },
          {
              "dimension1": "1783362600",
              "dimension2": "Firepower",
              "metric1": 64833293
          },
          {
              "dimension1": "1783449000",
              "dimension2": "Firepower",
              "metric1": 72007765
          },
          {
              "dimension1": "1783535400",
              "dimension2": "Firepower",
              "metric1": 53400713
          },
          {
              "dimension1": "1783621800",
              "dimension2": "Firepower",
              "metric1": 58052573
          },
          {
              "dimension1": "1783708200",
              "dimension2": "Firepower",
              "metric1": 45041902
          },
          {
              "dimension1": "1783794600",
              "dimension2": "Firepower",
              "metric1": 34237619
          },
          {
              "dimension1": "1783881000",
              "dimension2": "Firepower",
              "metric1": 62147775
          },
          {
              "dimension1": "1783967400",
              "dimension2": "Firepower",
              "metric1": 61530278
          },
          {
              "dimension1": "1784053800",
              "dimension2": "Firepower",
              "metric1": 61435271
          },
          {
              "dimension1": "1784140200",
              "dimension2": "Firepower",
              "metric1": 77708946
          },
          {
              "dimension1": "1784226600",
              "dimension2": "Firepower",
              "metric1": 56964132
          },
          {
              "dimension1": "1784313000",
              "dimension2": "Firepower",
              "metric1": 45976190
          },
          {
              "dimension1": "1784399400",
              "dimension2": "Firepower",
              "metric1": 22483556
          },
          {
              "dimension1": "1784485800",
              "dimension2": "Firepower",
              "metric1": 41652210
          },
          {
              "dimension1": "1781980200",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 1129041554
          },
          {
              "dimension1": "1782066600",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 1177624752
          },
          {
              "dimension1": "1782153000",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 1186868355
          },
          {
              "dimension1": "1782239400",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 623755322
          },
          {
              "dimension1": "1782325800",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 950780087
          },
          {
              "dimension1": "1782412200",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 892294508
          },
          {
              "dimension1": "1782498600",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 996662191
          },
          {
              "dimension1": "1782585000",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 1031923585
          },
          {
              "dimension1": "1782671400",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 1090534461
          },
          {
              "dimension1": "1782757800",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 1048504234
          },
          {
              "dimension1": "1782844200",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 888830274
          },
          {
              "dimension1": "1782930600",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 852817768
          },
          {
              "dimension1": "1783017000",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 956374277
          },
          {
              "dimension1": "1783103400",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 945129405
          },
          {
              "dimension1": "1783189800",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 853154739
          },
          {
              "dimension1": "1783276200",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 903661344
          },
          {
              "dimension1": "1783362600",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 896551946
          },
          {
              "dimension1": "1783449000",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 929780123
          },
          {
              "dimension1": "1783535400",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 809120353
          },
          {
              "dimension1": "1783621800",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 926334729
          },
          {
              "dimension1": "1783708200",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 744087283
          },
          {
              "dimension1": "1783794600",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 578456261
          },
          {
              "dimension1": "1783881000",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 923900170
          },
          {
              "dimension1": "1783967400",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 962642806
          },
          {
              "dimension1": "1784053800",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 945597799
          },
          {
              "dimension1": "1784140200",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 960655729
          },
          {
              "dimension1": "1784226600",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 946603645
          },
          {
              "dimension1": "1784313000",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 755022220
          },
          {
              "dimension1": "1784399400",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 267110320
          },
          {
              "dimension1": "1784485800",
              "dimension2": "Fortinet Fortigate Firewall",
              "metric1": 410750325
          },
          {
              "dimension1": "1781980200",
              "dimension2": "Palo Alto Firewall",
              "metric1": 15525373
          },
          {
              "dimension1": "1782066600",
              "dimension2": "Palo Alto Firewall",
              "metric1": 21545056
          },
          {
              "dimension1": "1782153000",
              "dimension2": "Palo Alto Firewall",
              "metric1": 20240043
          },
          {
              "dimension1": "1782239400",
              "dimension2": "Palo Alto Firewall",
              "metric1": 13178163
          },
          {
              "dimension1": "1782325800",
              "dimension2": "Palo Alto Firewall",
              "metric1": 19077621
          },
          {
              "dimension1": "1782412200",
              "dimension2": "Palo Alto Firewall",
              "metric1": 15376705
          },
          {
              "dimension1": "1782498600",
              "dimension2": "Palo Alto Firewall",
              "metric1": 17061823
          },
          {
              "dimension1": "1782585000",
              "dimension2": "Palo Alto Firewall",
              "metric1": 12874988
          },
          {
              "dimension1": "1782671400",
              "dimension2": "Palo Alto Firewall",
              "metric1": 19367616
          },
          {
              "dimension1": "1782757800",
              "dimension2": "Palo Alto Firewall",
              "metric1": 16446629
          },
          {
              "dimension1": "1782844200",
              "dimension2": "Palo Alto Firewall",
              "metric1": 16393905
          },
          {
              "dimension1": "1782930600",
              "dimension2": "Palo Alto Firewall",
              "metric1": 14897399
          },
          {
              "dimension1": "1783017000",
              "dimension2": "Palo Alto Firewall",
              "metric1": 14093772
          },
          {
              "dimension1": "1783103400",
              "dimension2": "Palo Alto Firewall",
              "metric1": 12325592
          },
          {
              "dimension1": "1783189800",
              "dimension2": "Palo Alto Firewall",
              "metric1": 11791541
          },
          {
              "dimension1": "1783276200",
              "dimension2": "Palo Alto Firewall",
              "metric1": 15006558
          },
          {
              "dimension1": "1783362600",
              "dimension2": "Palo Alto Firewall",
              "metric1": 15971101
          },
          {
              "dimension1": "1783449000",
              "dimension2": "Palo Alto Firewall",
              "metric1": 15805600
          },
          {
              "dimension1": "1783535400",
              "dimension2": "Palo Alto Firewall",
              "metric1": 14461626
          },
          {
              "dimension1": "1783621800",
              "dimension2": "Palo Alto Firewall",
              "metric1": 15612063
          },
          {
              "dimension1": "1783708200",
              "dimension2": "Palo Alto Firewall",
              "metric1": 8776330
          },
          {
              "dimension1": "1783794600",
              "dimension2": "Palo Alto Firewall",
              "metric1": 10713866
          },
          {
              "dimension1": "1783881000",
              "dimension2": "Palo Alto Firewall",
              "metric1": 15363306
          },
          {
              "dimension1": "1783967400",
              "dimension2": "Palo Alto Firewall",
              "metric1": 15056518
          },
          {
              "dimension1": "1784053800",
              "dimension2": "Palo Alto Firewall",
              "metric1": 15057856
          },
          {
              "dimension1": "1784140200",
              "dimension2": "Palo Alto Firewall",
              "metric1": 25595499
          },
          {
              "dimension1": "1784226600",
              "dimension2": "Palo Alto Firewall",
              "metric1": 18649874
          },
          {
              "dimension1": "1784313000",
              "dimension2": "Palo Alto Firewall",
              "metric1": 10220020
          },
          {
              "dimension1": "1784399400",
              "dimension2": "Palo Alto Firewall",
              "metric1": 10273736
          },
          {
              "dimension1": "1784485800",
              "dimension2": "Palo Alto Firewall",
              "metric1": 10412819
          }
      ],
      "headers": [
          {
              "disp": "Day",
              "type": "timestamp",
              "value": "dimension1"
          },
          {
              "disp": "Platform",
              "type": "text",
              "value": "dimension2"
          },
          {
              "disp": "Count",
              "type": "number",
              "value": "metric1"
          }
      ]
  }
}

  child

  treeStruct={}

  rootList=[]

  levelList

  selectedNode=''

  selected=[]

  chipsLimit=5

  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    public _service: UserLoginService,
    public sharedService: SharedService,
    private access: AuthService,
    public matdialog: MatDialog,
    private toastservice: ToastService,

  ) { }

  private renderLineChart(chart: any): void {

    d3.select('#chart').selectAll('*').remove();

    const margin = { top: 20, right: 20, bottom: 40, left: 55 };

    const width = 700;
    const height = 320;

    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.top - margin.bottom;

    const headers = chart.widgetdata.headers;

    const xHeader = headers.find((h: any) => h.type === "timestamp");
    const yHeader = headers.find((h: any) => h.type === "number");

    const xField = xHeader.value;
    const yField = yHeader.value;

    const data = chart.widgetdata.rows.map((row: any) => ({
        x: new Date(Number(row[xField]) * 1000),
        y: Number(row[yField])
    }));

    const svg = d3.select("#chart")
        .append("svg")
        .attr("width", width)
        .attr("height", height);

    const g = svg.append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

    const x = d3.scaleTime()
        .domain(d3.extent(data, d => d.x) as [Date, Date])
        .range([0, innerWidth]);

    const y = d3.scaleLinear()
        .domain([0, d3.max(data, d => d.y)!])
        .nice()
        .range([innerHeight, 0]);

    // Grid
    g.append("g")
        .call(
            d3.axisLeft(y)
                .ticks(6)
                .tickSize(-innerWidth)
                .tickFormat(() => "")
        )
        .call(g => g.select(".domain").remove())
        .call(g => g.selectAll("line")
            .attr("stroke", "#D9DFE8")
            .attr("stroke-width", 1));

    // X Axis
    g.append("g")
        .attr("transform", `translate(0,${innerHeight})`)
        .call(
            d3.axisBottom(x)
                .ticks(10)
                .tickFormat(d3.timeFormat("%d %b") as any)
        )
        .call(g => g.selectAll("line").remove())
        .call(g => g.select(".domain")
            .attr("stroke", "#60656F")
            .attr("stroke-width", 1.4))
        .call(g => g.selectAll("text")
            .style("font-size", "11px")
            .style("font-family", "Roboto")
            .attr("fill", "#666B75"));

    // Y Axis
    g.append("g")
        .call(
            d3.axisLeft(y)
                .ticks(6)
                .tickFormat((d: any) => {
                    const value = Number(d);

                    if (value === 0) return "0";
                    if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
                    if (value >= 1000) return `${Math.round(value / 1000)}K`;

                    return value;
                })
        )
        .call(g => g.select(".domain").remove())
        .call(g => g.selectAll("line").remove())
        .call(g => g.selectAll("text")
            .style("font-size", "11px")
            .style("font-family", "Roboto")
            .attr("fill", "#666B75"));

    // Line
    const line = d3.line<any>()
        .curve(d3.curveLinear)     // Straight segments like ECharts
        .x(d => x(d.x))
        .y(d => y(d.y));

        g.append("path")
        .datum(data)
        .attr("d", line)
        .attr("fill", "none")
        .style("fill", "none", "important")
        .style("stroke", chart.style.color_palette[0], "important")
        .style("stroke-width", "2px", "important")
        .style("stroke-opacity", "1", "important")
        .style("stroke-linecap", "round", "important")
        .style("stroke-linejoin", "round", "important")
        .style("filter", "none", "important")
        .style("opacity", "1", "important");

    // Diamond markers
    g.selectAll(".point")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "point")
        .attr("width", 3.5)
        .attr("height", 3.5)
        .attr("fill", chart.style.color_palette[0])
        .attr("transform", (d: any) => {
            const px = x(d.x);
            const py = y(d.y);
            return `translate(${px - 1.5},${py - 1.5}) rotate(45 1.5 1.5)`;
        });

}

private renderStackedAreaChart(chart: any): void {

  d3.select("#chart").selectAll("*").remove();

  const margin = { top: 25, right: 20, bottom: 45, left: 70 };

  const width = 760;
  const height = 420;

  const innerWidth = width - margin.left - margin.right;
  const innerHeight = height - margin.top - margin.bottom;

  const headers = chart.widgetdata.headers;

  const xHeader = headers.find((h: any) => h.type === "timestamp");
  const yHeader = headers.find((h: any) => h.type === "number");
  const seriesHeader = headers.find((h: any) => h.type === "text");

  const xField = xHeader.value;
  const yField = yHeader.value;
  const seriesField = seriesHeader.value;

  //-------------------------------------------------------
  // Group rows by date
  //-------------------------------------------------------

  const grouped = d3.group(
      chart.widgetdata.rows,
      (d: any) => Number(d[xField])
  );

  //-------------------------------------------------------
  // Find all platforms
  //-------------------------------------------------------

  const keys: string[] = [...new Set<string>(
    chart.widgetdata.rows.map((r: any) => r.dimension2)
)].sort((a, b) => a.localeCompare(b));
  //-------------------------------------------------------
  // Pivot into stack format
  //-------------------------------------------------------
  const map = new Map<number, any>();

  chart.widgetdata.rows.forEach((row: any) => {
  
      const ts = Number(row.dimension1);
  
      if (!map.has(ts)) {
  
          const obj: any = {
              date: new Date(ts * 1000)
          };
  
          // initialize every platform
          keys.forEach(k => obj[k] = 0);
  
          map.set(ts, obj);
      }
  
      map.get(ts)[row.dimension2] = Number(row.metric1);
  });
  
  const stackedInput = Array.from(map.values())
      .sort((a, b) => +a.date - +b.date);
  //-------------------------------------------------------
  // Build stack
  //-------------------------------------------------------

  const stack = d3.stack<any>()
    .keys(keys);

const stackedSeries = stack(stackedInput);

//console.log(stackedInput);
//console.log(stackedSeries);

  //-------------------------------------------------------
  // SVG
  //-------------------------------------------------------

  const svg = d3.select("#chart")
      .append("svg")
      .attr("width", width)
      .attr("height", height);

  const g = svg.append("g")
      .attr(
          "transform",
          `translate(${margin.left},${margin.top})`
      );

  //-------------------------------------------------------
  // Scales
  //-------------------------------------------------------

  const x = d3.scaleTime()
      .domain(d3.extent(stackedInput, d => d.date) as [Date, Date])
      .range([0, innerWidth]);

  const maxY = d3.max(stackedSeries, layer =>
      d3.max(layer, d => d[1])
  )!;

  const y = d3.scaleLinear()
      .domain([0, maxY])
      .nice()
      .range([innerHeight, 0]);

  //-------------------------------------------------------
  // Grid
  //-------------------------------------------------------

  g.append("g")
      .call(
          d3.axisLeft(y)
              .ticks(6)
              .tickSize(-innerWidth)
              .tickFormat(() => "")
      )
      .call(g => g.select(".domain").remove())
      .call(g =>
          g.selectAll("line")
              .attr("stroke", "#DCE3EC")
              .attr("stroke-width", 1)
      );

  //-------------------------------------------------------
  // X Axis
  //-------------------------------------------------------

  g.append("g")
      .attr("transform", `translate(0,${innerHeight})`)
      .call(
          d3.axisBottom(x)
              .ticks(10)
              .tickFormat(d3.timeFormat("%d %b") as any)
      )
      .call(g => g.selectAll("line").remove())
      .call(g =>
          g.select(".domain")
              .attr("stroke", "#68717D")
      )
      .call(g =>
          g.selectAll("text")
              .style("font-family", "Roboto")
              .style("font-size", "11px")
              .attr("fill", "#5E6470")
      );

  //-------------------------------------------------------
  // Y Axis
  //-------------------------------------------------------

  g.append("g")
      .call(
          d3.axisLeft(y)
              .ticks(6)
              .tickFormat((v: any) => {

                  if (v >= 1e9)
                      return (v / 1e9).toFixed(1) + "Bn";

                  if (v >= 1e6)
                      return Math.round(v / 1e6) + "Mn";

                  if (v >= 1e3)
                      return Math.round(v / 1e3) + "K";

                  return v;

              })
      )
      .call(g => g.select(".domain").remove())
      .call(g => g.selectAll("line").remove())
      .call(g =>
          g.selectAll("text")
              .style("font-family", "Roboto")
              .style("font-size", "11px")
              .attr("fill", "#5E6470")
      );

  //-------------------------------------------------------
  // Everything below this point will be Part 2
  //-------------------------------------------------------
  const area = d3.area<any>()
  .x((d: any) => x(d.data.date))
  .y0((d: any) => y(d[0]))
  .y1((d: any) => y(d[1]))
  .curve(d3.curveMonotoneX);

g.selectAll(".stack-area")
  .data(stackedSeries)
  .enter()
  .append("path")
  .attr("class", "stack-area")
  .attr("d", area)
//   .attr("fill", (d: any, i: number) =>
//     chart.style.color_palette[i % chart.style.color_palette.length].color
// )
  .attr("fill-opacity", 1)
  .attr("stroke", "none");


  const line = d3.line<any>()
    .x((d: any) => x(d.data.date))
    .y((d: any) => y(d[1]))
    .curve(d3.curveMonotoneX);

g.selectAll(".stack-line")
    .data(stackedSeries)
    .enter()
    .append("path")
    .attr("class", "stack-line")
    .attr("fill", "none")
    .attr("d", line)
    .style(
      "fill",
      (d: any, i: number) => chart.style.color_palette[i],
      "important"
  )
  .style(
      "stroke",
      (d: any, i: number) => chart.style.color_palette[i],
      "important"
  )
    .attr("stroke-width", 2.5)
    .attr("stroke-linejoin", "round")
    .attr("stroke-linecap", "round");


    stackedSeries.forEach((series: any, seriesIndex: number) => {

      g.selectAll(`.marker-${seriesIndex}`)
          .data(series)
          .enter()
          .append("circle")
          .attr("class", `marker-${seriesIndex}`)
          .attr("cx", (d: any) => x(d.data.date))
          .attr("cy", (d: any) => y(d[1]))
          .attr("r", 3.5)
          .attr(
              "fill",
              chart.style.color_palette[
                  seriesIndex % chart.style.color_palette.length
              ],"important"
          )
          .attr("stroke", "#ffffff")
          .attr("stroke-width", 1.5);
  
  });

  //-------------------------------------------------------
// Legend
//-------------------------------------------------------

const legend = svg.append("g")
.attr(
    "transform",
    `translate(${margin.left},${height - 10})`
);

const legendItems = legend
.selectAll(".legend-item")
.data(keys)
.enter()
.append("g")
.attr("class", "legend-item")
.attr("transform", (d, i) => `translate(${i * 170},0)`);

legendItems.append("circle")
.attr("r", 5)
.attr("cx", 0)
.attr("cy", 0)
.attr("fill", (d, i) =>
    chart.style.color_palette[
        i % chart.style.color_palette.length
    ],"important"
);

legendItems.append("text")
.attr("x", 12)
.attr("y", 4)
.style("font-size", "12px")
.style("font-family", "Roboto")
.attr("fill", "#444")
.text(d => d);

// const tooltip = d3.select("body")
//     .append("div")
//     .style("position", "absolute")
//     .style("background", "#fff")
//     .style("border", "1px solid #d9d9d9")
//     .style("border-radius", "4px")
//     .style("padding", "8px")
//     .style("font-family", "Roboto")
//     .style("font-size", "12px")
//     .style("pointer-events", "none")
//     .style("box-shadow", "0 2px 8px rgba(0,0,0,.15)")
//     .style("display", "none");

//     stackedSeries.forEach((series: any, seriesIndex: number) => {

//       g.selectAll(`.marker-${seriesIndex}`)
//           .data(series)
//           .enter()
//           .append("circle")
//           .attr("cx", (d: any) => x(d.data.date))
//           .attr("cy", (d: any) => y(d[1]))
//           .attr("r", 3.5)
//           .attr(
//               "fill",
//               chart.style.color_palette[
//                   seriesIndex % chart.style.color_palette.length
//               ]
//           )
//           .attr("stroke", "#fff")
//           .attr("stroke-width", 1.5)
  
//           .on("mouseover", function(event: any, d: any) {
  
//               d3.select(this)
//                   .transition()
//                   .duration(100)
//                   .attr("r", 6);
  
//               tooltip
//                   .style("display", "block")
//                   .html(`
//                       <b>${keys[seriesIndex]}</b><br>
//                       ${d3.timeFormat("%d %b %Y")(d.data.date)}<br>
//                       Value :
//                       ${(d[1]-d[0]).toLocaleString()}
//                   `);
  
//           })
  
//           .on("mousemove", function(event: any){
  
//               tooltip
//                   .style("left", (event.pageX+15)+"px")
//                   .style("top", (event.pageY-30)+"px");
  
//           })
  
//           .on("mouseout", function(){
  
//               d3.select(this)
//                   .transition()
//                   .duration(100)
//                   .attr("r",3.5);
  
//               tooltip.style("display","none");
  
//           });
  
//   });

  g.selectAll(".stack-area")
    .attr("opacity",0)
    .transition()
    .duration(800)
    .attr("opacity",1);

    g.selectAll(".stack-line")
    .attr("opacity",0)
    .transition()
    .delay(200)
    .duration(700)
    .attr("opacity",1);
}

  assetSearch = new FormControl()

  filterList(str,mode?,level?){
    // console.log(str)
    

    this.levelList.forEach((list,index)=>{

      if(mode === 'click'){
        if(list != level){

        let filtered=[]
        filtered = this.defaultStructure[list].filter((rule: any) => {
        if((rule.trim()).toLowerCase().includes((str.trim()).toLowerCase())){
          return rule
        }
      })
      this.structure[list]=filtered
      if(index == 0){
        this.structure[list]=filtered        
      }
      else {
        this.structure[list]=filtered
      
        filtered.forEach(list=>{
          if(this.sampleData.nodes[list].childrenIds.length){
            // console.log(this.sampleData.nodes[list].childrenIds)
            this.sampleData.nodes[list].childrenIds.forEach(child=>{
              if(!this.structure[this.sampleData.nodes[child].level].includes(this.sampleData.nodes[child].id)){
                this.structure[this.sampleData.nodes[child].level].push(this.sampleData.nodes[child].id)
              }
            })
          }
          // console.log(list)
          let strList = list.split('/')
          // console.log(strList)
          if(strList.length <=2 ){
            // console.log(this.sampleData.nodes[strList[0]])
            if(!this.structure[this.sampleData.nodes[strList[0]].level].includes(this.sampleData.nodes[strList[0]].id)){
              this.structure[this.sampleData.nodes[strList[0]].level].push(this.sampleData.nodes[strList[0]].id)
            }
          }else{

            let pathList = strList.map((_, i) =>strList.slice(0, i + 1).join("/"))

           pathList.forEach(val=>{
            if(!this.structure[this.sampleData.nodes[val].level].includes(this.sampleData.nodes[val].id)){
              this.structure[this.sampleData.nodes[val].level].push(this.sampleData.nodes[val].id)
            }
           })
           
          }
          
        })


        // console.log(this.structure)
      }

        }
      }else{

        let filtered=[]
      filtered = this.defaultStructure[list].filter((rule: any) => {
        if((rule.trim()).toLowerCase().includes((str.trim()).toLowerCase())){
          return rule
        }
      })
      this.structure[list]=filtered
      if(index == 0){
        this.structure[list]=filtered        
      }
      else {
        this.structure[list]=filtered
       


        filtered.forEach(list=>{
          if(this.sampleData.nodes[list].childrenIds.length){
            // console.log(this.sampleData.nodes[list].childrenIds)
            this.sampleData.nodes[list].childrenIds.forEach(child=>{
              if(!this.structure[this.sampleData.nodes[child].level].includes(this.sampleData.nodes[child].id)){
                this.structure[this.sampleData.nodes[child].level].push(this.sampleData.nodes[child].id)
              }
            })
          }
          // console.log(list)
          let strList = list.split('/')
          // console.log(strList)
          if(strList.length <=2 ){
            // console.log(this.sampleData.nodes[strList[0]])
            if(!this.structure[this.sampleData.nodes[strList[0]].level].includes(this.sampleData.nodes[strList[0]].id)){
              this.structure[this.sampleData.nodes[strList[0]].level].push(this.sampleData.nodes[strList[0]].id)
            }
          }else{

            let pathList = strList.map((_, i) =>strList.slice(0, i + 1).join("/"))
          
           pathList.forEach(val=>{
            if(!this.structure[this.sampleData.nodes[val].level].includes(this.sampleData.nodes[val].id)){
              this.structure[this.sampleData.nodes[val].level].push(this.sampleData.nodes[val].id)
            }
           })
           
          }
          
        })


        // console.log(this.structure)
      }

      }

      
    })

   
  }

  getLevelList(){
    let list=[]
    Object.keys(this.sampleData.nodes).forEach(key=>{
      list.push(this.sampleData.nodes[key].level)
    })
    let listSet=new Set(list)
    return Array.from(listSet)
  }

  getRoot(){
    let list=[]
    let name=[]
    let level
    this.sampleData.roots.forEach(key=>{
      Object.keys(this.sampleData.nodes).forEach(data=>{
        if(this.sampleData.nodes[data].id === key){
          this.rootList.push(this.sampleData.nodes[data])
          name.push(data)
          level=this.sampleData.nodes[data].level
          list.push(this.sampleData.nodes[data])
        }
      })
    })
    this.structure[level]=name
    // console.log(this.structure)
    return list
  }

  getChildren(id){
    let childObj={}
    Object.keys(this.sampleData.nodes).forEach(key=>{
      if(this.sampleData.nodes[key].id === id){
        if(this.sampleData.nodes[key].childrenIds.length){
          this.sampleData.nodes[key].childrenIds.forEach(childKey=>{
            childObj[childKey] = (this.sampleData.nodes[childKey])
          })
        }
      }
    })
    // console.log(childObj)
    return childObj
  }

  getLevel(id){
    let level
    Object.keys(this.sampleData.nodes).forEach(key=>{
      if(this.sampleData.nodes[key].id === id){
        level = this.sampleData.nodes[key].level
      }
    })
    return level
  }

  getLabel(id){
    let label
    Object.keys(this.sampleData.nodes).forEach(key=>{
      if(this.sampleData.nodes[key].id === id){
        label = this.sampleData.nodes[key].label
      }
    })
    return label
  }

  getParentId(id){
    let parent
    Object.keys(this.sampleData.nodes).forEach(key=>{
      if(this.sampleData.nodes[key].id === id){
        parent = this.sampleData.nodes[key].parentId
      }
    })
    return parent
  }

  removeChip(chip){
    let index = this.selected.findIndex(val=> val === chip)
    this.selected.splice(index,1)
  }

  rootClick(root,mode){
    let level
    let list=[]
    let temp={}
    if(this.selectedNode === root){
      this.selectedNode=''
      this.structure=JSON.parse(JSON.stringify(this.defaultStructure))
    }else{
      this.selectedNode=root
      if(this.sampleData.nodes[root].childrenIds.length){
        this.filterList(root,'click',this.getLevel(root))
      }else{
//console.log(root)
        let string=JSON.parse(JSON.stringify(root.replaceAll("/", ".")))
        if(this.selected.length < this.chipsLimit && !this.selected.includes(string)){
          this.selected.push(string)
        }
        this.selectedNode=''
        this.structure=JSON.parse(JSON.stringify(this.defaultStructure))
      }
    }

    

    // Object.keys(this.sampleData.nodes).forEach(key=>{
    //   if(root === key){
    //     if(this.sampleData.nodes[key].childrenIds.length){
    //       this.sampleData.nodes[key].childrenIds.forEach(childKey=>{

    //       })
    //     }
    //   }
    // })

    // this.assetSearch.setValue(root)
    // Object.keys(this.structure).forEach(val=>{
    //   this.structure[val]=[]
    // })
    // Object.keys(this.sampleData.nodes).forEach(key=>{
    //   if(key === root){
    //     this.sampleData.nodes[key].childrenIds.forEach(data=>{
    //       level=this.sampleData.nodes[data].level
    //       // if(!this.structure[level].includes(data)){
    //       //   this.structure[level].push(data)
    //       // }
    //       // console.log({level})
    //       list.push(data)
    //     })
    //   }
    // })
    // if(level && list.length){
    //   this.structure[level]=list
    // }

    // console.log(this.structure)

    // this.treeStruct[root]=this.getChildren(root)

    
    // if(mode === 'root'){
    // }
    // console.log(root)

    // console.log(this.getChildren(root))
    // console.log(this.getLevel(root))
    // if(mode)
    // console.log(root)
    // Object.keys(this.sampleData.nodes).forEach(key=>{
    //   // console.log(key,"->",root)
    //   if(key === root){
    //     this.child=this.sampleData.nodes[key]
    //   }
    // })
    // console.log(this.treeStruct)
  }

  originalOrder = (a: KeyValue<number,string>, b: KeyValue<number,string>): number => {
    return 0;
  }

  getDefault(){
    this.levelList.forEach(level=>{
      let list=[]
      Object.keys(this.sampleData.nodes).forEach(key=>{
        if(level === this.sampleData.nodes[key].level){
          list.push(key)
        }
      })
      this.defaultStructure[level]=list
    })
    this.structure = JSON.parse(JSON.stringify(this.defaultStructure))
    // console.log(this.structure)
  }

  ngAfterViewInit(): void {

    this.action.valueChanges.subscribe(val=>{
// console.log(val)
    })
    this.renderLineChart(this.sample_chart)
    // this.renderStackedAreaChart(this.sample_area_stack)
    this.UNameRef.nativeElement.focus();
    this.assetSearch.valueChanges.pipe(takeUntil(this.$destroy)).subscribe(val=>{
      this.filterList(val)
    })
  }

  ngOnInit(): void {
    this.levelList = this.getLevelList()
    this.getDefault()
    // this.getRoot()
    this.forgotPwdState = 0;
    this.setPwd = this.fb.group({
      user_name: [],
      newPwd: [null, [
        Validators.required,
        VerifyPasswordCombination(this.strongPassword),
        Validators.minLength(this.validationData.password.minlength),
        Validators.maxLength(this.validationData.password.maxlength)],
        [PrePasswordValidator.createValidator(this.sharedService)]
      ],
      reEnterPwd: [null, [
        Validators.required,
        Validators.required,
        Validators.minLength(this.validationData.password.minlength),
        Validators.maxLength(this.validationData.password.maxlength)]]
    }, {
      validators: ConfirmedValidator('newPwd', 'reEnterPwd')
    })
    this.sharedService.customerChanged_.subscribe((customer) => {
      this.changeCustomer(customer)
      this.sharedService.serviceProviderName = customer.serviceProvider
    })

  }

  //dashboard module have to be loaded AFTER this._service.getMetaData(),
  //so async - await is used 
  login() {
  
    if (!this.userName) {
      this.errorMessage = "Please enter user name";  //this.forgotPwdmetaData.genErrors.uname //
      this.userName.focus;
    } else if (!this.pwd) {
      this.errorMessage = "Please enter password";  //this.forgotPwdmetaData.genErrors.uname //
      this.pwd.focus;
    }
    else {
      this.sharedService.mat_spinner_login_state = true;
      //this.sharedService.userName = this.userName;
      this._service.getUser(this.userName, this.pwd, this.force_login)
        .then((val:any) => {
          
          this.sharedService.userName = this.userName;
          this.errorMessage = '';
          this.force_login = false;
          this._service.getMetaData({ "user_name": this.userName })
            .then(async metadata => {
              this.validationData = this.sharedService.metaData.commonData.userDetailvalidationData
              this.access.requestAccessToken()
              this._service.getTimezone({ "user_name": this.userName }).toPromise()
                .then((timezone) => {
//console.log(timezone)
                  this.sharedService.timeZone = timezone['timezone'];
                  this.sharedService.mat_spinner_login_state = false;
                  this.router.navigateByUrl('home');
                  // ----------------------//
                })
                .catch(err => {
                  this.sharedService.mat_spinner_login_state = false;
                })
            })
            .catch(err => {
              this.sharedService.mat_spinner_login_state = false;
            })
        })
        .catch((err) => {
          // this._service.getTimezone({ "user_name": this.userName }).toPromise()
          // .then((timezone) => {
          //   console.log(timezone,this.userName)
          //   this.sharedService.timeZone = timezone['timezone'];
          //   this.sharedService.mat_spinner_login_state = false;
          //   this.router.navigateByUrl('home');
          //   this.sharedService.userName = this.userName;
          //   // ----------------------//
          // })
          // .catch(err => {
          //   this.sharedService.mat_spinner_login_state = false;
          // })
          // console.log(err)
          this.force_login = false;
          this.sharedService.mat_spinner_login_state = false;

          if (err.hasOwnProperty('refcode')) {
            if (err.refcode.slice(0, 3) === "112") {
              this.errorMessage = '';
              this.terminate_sesssion_alert(err.errmsg,err.last_login);
            } else {
              this.errorMessage = err.errmsg;
            }
          } else {
            this.errorMessage = err;
          }
        })
    }
    this.sharedService.menu = this.sharedService?.metaData?.apps?.sensor_metadata?.menuList
    
  }

  terminate_sesssion_alert(errmsg: string,last_login:string) {
    const termiateSessionDialogRef = this.matdialog.open(TerminateSessionComponent, {
      width: "25vw", height: "24vh", data: {last_login}, autoFocus: false,
      disableClose: true
    })
    termiateSessionDialogRef.afterClosed().subscribe((confirm) => {
      if (confirm) {
        this.force_login = true;
        this.login()
      } else {
        this.errorMessage = errmsg;
      }
    })

  }

  onKeyDown_UName(event) {
    this.clearErrormsg();
    switch (event.key) {
      case "ArrowDown":
      case "Enter":
        this.pwdRef.nativeElement.focus();
    }
  }
  onKeyDown_pwd(event) {
    this.clearErrormsg();
    switch (event.key) {
      case "ArrowDown":
      case "Enter":
        this.signInRef.nativeElement.focus();
    }
  }

  clearErrormsg() {
    this.errorMessage = null
  }

  get userName() { return this.loginForm.get('userName').value; }

  get pwd() { return this.loginForm.get('pwd').value; }

  forgotPassword_click() {
    this.errorMessage = null
    if (this.userName) {
      this.mat_spinner_forgotpwd_state = true;
      this.sharedService.userName = this.userName;
      // api to get metadata and question list
      this._service.getUserSecretQuestions({ "user_name": this.userName })
        .pipe(takeUntil(this.$destroy))
        .subscribe((val: any) => {
          if (val.error) {
            this.errorMessage = val.errmsg
          }
          else {
            this.validationData = val.validation_data
            this.forgotPwdmetaData = val.meta_data
            this.qtnList = val.qtnList;
            this.newPwdmetaData = this.forgotPwdmetaData.newPwd //
            this.strongPassword = this.newPwdmetaData.pwdStrength.strength;

            //create formcontrols for new pwd - setPwd formGroup

            if (!this.qtnList) {
              this.errorMessage = this.forgotPwdmetaData.genErrors.qtns // "No questions"
              this.userName.focus;
            } else {
              this.errorMessage = null
              this.forgotPwdState = 1
            }

            //  call this api to send the 4 digit code to user email id

            this._service.sendAuthCode({ "user_name": this.userName })
              .pipe(takeUntil(this.$destroy))
              .subscribe((val: any) => {
                if (val) {
                  this.display = "02:00";
                  this.timer(2);
                  this.mat_spinner_forgotpwd_state = false;

                  this.toastservice.show({
                    text: val.status,
                    type: ToastType.success
                  })

                }
                // this.errorMessage= this.forgotPwdmetaData.genErrors.aCode // "Auth code sent"
              })
          }
        })
    } else {
      this.errorMessage = "Please enter user name";  //this.forgotPwdmetaData.genErrors.uname //
      this.userName.focus;
    }

  }
  get ans1() {
    return this.pwdVerify.get('ans1');
  }

  get ans2() {
    return this.pwdVerify.get('ans2');
  }

  get verificationCode() {
    return this.pwdVerify.get('verificationCode');
  }

  resend_click() {
    this.timerState = false;
    this.mat_spinner_forgotpwd_state = true;
    this.display = "";
    this._service.sendAuthCode({ "user_name": this.sharedService.userName }).pipe(takeUntil(this.$destroy)).subscribe((val: any) => {
      if (val) {
        this.mat_spinner_forgotpwd_state = false
        this.toastservice.show({
          text: val.status,
          type: ToastType.success
        })
      } else {
        // this.errorMessage= this.forgotPwdmetaData.genErrors.aCode // "Auth code sent"
        this.timer(2);
      }
    })
  }

  timer(minute) {
    // return  new Promise((res,rej)=>{
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    const prefix = minute < 10 ? "0" : "";
    this.timeControler = setInterval(() => {
      seconds--;
      if (statSec != 0) {
        statSec--;
      } else {
        statSec = 59;
      }
      if (statSec < 10) {
        textSec = "0" + statSec;
      } else {
        textSec = statSec;
      }

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.timerState = true;
        clearInterval(this.timeControler);
      }
    }, 1000);
  }

  cancel_click() {
    clearInterval(this.timeControler)
    this.mat_spinner_forgotpwd_state = false;
    this.display = "";
    this.timerState = false
    this.errorMessage = null
    this.forgotPwdState = 0
    this.pwdVerify.reset()
  }

  load_setNewPassword() {
    this.pwdVerify.get("user_name").patchValue(this.userName)
    this.errorMessage = null
    if (this.pwdVerify.valid) {
      // call api to verify the SecretQA and auth code, only when the form is valid;
      this.sharedService.userName = this.userName
      this._service.postSecretQA(this.pwdVerify.value)
        .pipe(takeUntil(this.$destroy))
        .subscribe((val: any) => {
          if (val.error) {
            this.showForgotError = true
            this.errorMessage = val.errmsg
          } else {
            this.errorMessage = null
            this.forgotPwdState = 2
            this.pwdVerify.reset()
          }
        })
    }
  }

  get newPwd() {
    return this.setPwd.get('newPwd')
  }

  get setPwdFC() {
    return this.setPwd.controls
  }

  get reEnterPwd() {
    return this.setPwd.get('reEnterPwd')
  }

  submit_click() {
    if (this.newPwd.valid && this.reEnterPwd.valid) {
      this.sharedService.postNewpwd({ "user_name": this.userName, "pwd": this.newPwd.value }).pipe(takeUntil(this.$destroy)).subscribe((val: any) => {
        if (val.err) {
          this.showNewPassError = true;
          this.errorMessage = val.errmsg
        } else {
          this.newPwd.reset()
          this.reEnterPwd.reset()
          this.errorMessage = null
          this.forgotPwdState = 0
        }
      })
    }
  }
  changeCustomer(customer) {
    this.sharedService.mat_spinner_login_state = true;

    this.access.accessToken({ "change_status": true, "customer": customer.customerFullName })
    this.errorMessage = '';
    setTimeout(() => {
      this._service.getMetaData({ "user_name": this.userName })
        .then(async metadata => {
          this.validationData = this.sharedService.metaData.commonData.userDetailvalidationData
          this._service.getTimezone({ "user_name": this.userName }).toPromise()
            .then((timezone) => {
              this.sharedService.timeZone = timezone['timezone'];
              this.sharedService.mat_spinner_login_state = false;
              this.router.navigateByUrl('home');
              // ----------------------//
            })
            .catch(err => {
              this.sharedService.mat_spinner_login_state = false;
            })

        })
        .catch(err => {
          this.sharedService.mat_spinner_login_state = false;
        })

    }, 200);
  }
  ngOnDestroy(): void {
    this.$destroy.next(true)
    this.$destroy.unsubscribe()
  }
}